import { Link } from "react-router-dom";
import { Sparkles, ArrowRight, X } from "lucide-react";
import { useState } from "react";

export default function DemoBanner() {
  const [hidden, setHidden] = useState(false);
  if (hidden) return null;

  return (
    <div
      data-testid="demo-banner"
      className="bg-gradient-to-r from-[#064E3B] via-[#065F46] to-[#047857] text-white"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-2.5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          <span className="flex-shrink-0 inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#10B981]/30 border border-[#86EFAC]/40">
            <Sparkles className="w-3 h-3 text-[#86EFAC]" />
          </span>
          <span className="font-figtree text-xs sm:text-sm truncate">
            <strong className="font-semibold tracking-wide">DEMO MODE</strong>
            <span className="hidden sm:inline text-white/80">
              {" "}
              · Sample patients only. Nothing is saved.
            </span>
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Link
            to="/signup"
            data-testid="demo-banner-signup-link"
            className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-white text-[#065F46] text-xs font-semibold hover:bg-[#D1FAE5] transition-colors whitespace-nowrap"
          >
            Start free trial
            <ArrowRight className="w-3 h-3" />
          </Link>
          <button
            aria-label="Dismiss banner"
            data-testid="demo-banner-dismiss"
            onClick={() => setHidden(true)}
            className="inline-flex items-center justify-center w-6 h-6 rounded-full hover:bg-white/10 text-white/70 hover:text-white transition-colors"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
